"use client";

import { useState } from "react";

import { Container } from "@/src/components/ui/Container";
import Section from "@/src/components/ui/Section";
import { Button } from "@/src/components/ui/Button";
import { CaseStudyCard } from "@/src/components/molecules/CaseStudyCard";
import type { CaseStudyCard as CaseStudyCardData } from "@/src/lib/case-studies/case-studies";

const PAGE_SIZE = 8;

interface CaseStudiesGridInteractiveProps {
  items: CaseStudyCardData[];
}

export function CaseStudiesGridInteractive({ items }: CaseStudiesGridInteractiveProps) {
  const [visible, setVisible] = useState(PAGE_SIZE);
  const shown = items.slice(0, visible);
  const hasMore = items.length > visible;

  const leftColumn = shown.filter((_, index) => index % 2 === 0);
  const rightColumn = shown.filter((_, index) => index % 2 === 1);

  return (
    <Section className="bg-white">
      <Container>
        <div className="grid gap-x-8 md:gap-x-22 lg:gap-x-35.5 gap-y-16 md:grid-cols-2">
          <div className="flex flex-col gap-16 md:gap-35.5">
            {leftColumn.map((item) => (
              <CaseStudyCard key={item.slug} item={item} />
            ))}
          </div>

          <div className="flex flex-col gap-16 md:gap-35.5 md:mt-65">
            {rightColumn.map((item) => (
              <CaseStudyCard key={item.slug} item={item} />
            ))}
          </div>
        </div>

        {hasMore && (
          <div className="mt-14 text-center md:mt-20">
            <Button
              type="button"
              variant="secondary"
              onClick={() => setVisible((v) => v + PAGE_SIZE)}
              className="border border-neutral-700"
            >
              Load more
            </Button>
          </div>
        )}
      </Container>
    </Section>
  );
}
